import en from "./en.js";
import cn from "./cn.js";
import fcn from "./fcn.js";
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import zhtwLocale from "element-ui/lib/locale/lang/zh-TW";
import VueI18n from "vue-i18n";
import Vue from "vue";
Vue.use(VueI18n);
export  default new VueI18n({
    locale: "en", // 默认语言
    messages: {
      en, // 英文翻译文本
      cn, // 中文翻译文本
      fcn // 繁体中文翻译文本
    }
  });


// WEBPACK FOOTER //
// ./src/locales/index.js